/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

const LABELS = {
  SAVE: "Save",
  DELETE: "Delete",
  CANCEL: "Cancel",
  ENTITLEMENTS: "Manage Entitlements",
  ORGANIZATION: "Organization",
  APPLICATIONS: "Applications",
  SELECT_ORGANIZATION: "Select Organization",
  DELETE_SUB_ENTERPRISE: "Delete Account",
  AVAILABLE_MODULES: "Available Modules",
  SELECTED_MODULES: "Selected Modules",
};

const MESSAGES = {
  APPLICATION_HELPER_TEXT:
    "Name of one or more applications that contain available modules. You can select multiple values for this field.",
  ORGANIZATION_HELPER_TEXT:
    "Name of the organization that sells the application, such as Blue Yonder or a Blue Yonder partner that enrolls sellable modules with LIAM.",
};

export { LABELS, MESSAGES };
